import { createFileRoute } from "@tanstack/react-router";
import { ServicePage, buildServiceMeta } from "@/components/ServicePage";
import { commercialContent } from "@/data/serviceContent";

const slug = "gas-station-cleaning";
const c = commercialContent[slug];

export const Route = createFileRoute("/commercial/gas-station-cleaning")({
  head: () => buildServiceMeta({
    title: c.title,
    description: c.intro[0].slice(0, 155),
    path: "/commercial/gas-station-cleaning",
  }),
  component: () => <ServicePage category="commercial" slug={slug} {...c} />,
});
